export default __webpack_public_path__ + "locales/sq-AL/Settings.json?hash=6d4677fdd185c7221ec54b04e7ccd1d0";